import { useFeatureFlagEnabled } from 'posthog-js/react';

import { useAuthContext } from 'src/auth/hooks';
import { DEVELOPMENT, IS_LOCALHOST } from 'src/config-global';
import { FEATURE_FLAGS } from 'src/utils/feature-flags';

// TODO: temporary — the PostHog flag quota is exhausted, so live sessions are opened by
// environment and an allowlist of platforms. Remove once the `live-sessions` flag is usable again.
const LIVE_SESSIONS_PLATFORM_IDS: readonly string[] = ['fdf74b5a-4b36-4775-95fc-1c06e73a28c9'];

export const useLiveSessionsEnabled = () => {
  const { platformId } = useAuthContext();
  const flagEnabled = useFeatureFlagEnabled(FEATURE_FLAGS.LIVE_SESSIONS);

  return (
    !!flagEnabled ||
    IS_LOCALHOST ||
    DEVELOPMENT ||
    (!!platformId && LIVE_SESSIONS_PLATFORM_IDS.includes(platformId))
  );
};
